import { useCustomizerNavigation } from '../hooks/index.js'
import { SlateEditor, SlateTree } from '../SlateEditor/index.js'

export const NavigationSidebarEditor = () => {
  const { navigationSlates } = useCustomizerNavigation()
  const { headerDisabled, sidebar1Disabled } = navigationSlates

  return (
    <SlateEditor
      slates={[
        { id: 'header', slate: navigationSlates.header },
        {
          id: 'sidebar1',
          slate: navigationSlates.sidebar1,
        },
      ]}
    >
      <div className="-ms-3 -me-3">
        {!headerDisabled && <SlateTree id="header" />}
        {!sidebar1Disabled && <SlateTree id="sidebar1" />}
      </div>
    </SlateEditor>
  )
}
